import { useEffect } from 'react';

import { FormikProps } from 'formik';

function useFocusOnFieldError<T>(form: FormikProps<T>) {
  useEffect(() => {
    const fieldErrors = Object.keys(form.errors);

    if (fieldErrors.length === 0) {
      return;
    }

    document.getElementsByName(fieldErrors[0])[0]?.focus();
  }, [form.errors]);
}

export default useFocusOnFieldError;
